
import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxGlobalTax.css';

const RedboxGlobalTax = () => {
  return (
    <>
      <Helmet>
        <title>Tax | Redbox Global</title>
        <meta
          name="description"
          content="Global tax insights, regulatory updates, corporate taxation analysis, and international compliance developments from Redbox Global."
        />
        <meta
          name="keywords"
          content="corporate tax, international taxation, tax compliance, global tax policy, transfer pricing, tax regulation, Redbox Global Tax"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/tax" />
        <meta property="og:title" content="Tax | Redbox Global" />
        <meta
          property="og:description"
          content="Expert insights on global tax policy, compliance, and corporate taxation trends."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tax | Redbox Global" />
        <meta
          name="twitter:description"
          content="International tax analysis and regulatory updates from Redbox Global."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&h=630&fit=crop"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/tax" />
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Tax</h1>
          <p className="page-subtitle">
            Global taxation insights, compliance updates, and fiscal policy analysis
          </p>
        </div>

        <div className="page-content">

          {/* Featured Article */}
          <a
            href="/article/global-minimum-tax-framework-2026"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&h=600&fit=crop"
                  alt="Global tax policy documents"
                />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">Featured Analysis</span> */}
                <h2>Global Minimum Tax Framework: What Multinationals Must Prepare For</h2>
                <p>
                  A detailed examination of the evolving global minimum tax regime
                  and its implications for multinational enterprises operating across jurisdictions.
                </p>
                <span className="article-meta">February 11, 2026</span>
              </div>
            </div>
          </a>

          {/* Article Grid */}
          <div className="content-grid">

            <a
              href="/article/transfer-pricing-updates-2026"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop"
                    alt="Financial documents and calculator"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Transfer Pricing</span> */}
                  <h2>Transfer Pricing Regulations Tighten in Key Markets</h2>
                  <p>
                    Governments introduce stricter documentation and reporting standards
                    aimed at enhancing transparency and preventing profit shifting.
                  </p>
                  <span className="article-meta">February 8, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/digital-services-tax-expansion"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1518186285589-2f7649de83e0?w=600&h=400&fit=crop"
                    alt="Digital economy concept"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Digital Taxation</span> */}
                  <h2>Expansion of Digital Services Taxes Across Europe and Asia</h2>
                  <p>
                    An overview of new digital tax measures impacting global technology
                    companies and cross-border service providers.
                  </p>
                  <span className="article-meta">February 6, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/corporate-tax-incentives-2026"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
                    alt="Corporate financial charts"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Corporate Tax</span> */}
                  <h2>Emerging Corporate Tax Incentives for Strategic Investment</h2>
                  <p>
                    How new fiscal policies are designed to attract foreign investment
                    and stimulate domestic economic growth.
                  </p>
                  <span className="article-meta">February 3, 2026</span>
                </div>
              </article>
            </a>

          </div>

        </div>
      </div>
    </>
  );
};

export default RedboxGlobalTax;
